import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import AdminLayout from './components/layout/AdminLayout';
import ProtectedRoute from './components/layout/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ServersPage from './pages/ServersPage';
import CustomersPage from './pages/CustomersPage';
import SubscriptionsPage from './pages/SubscriptionsPage';
import PaymentsPage from './pages/PaymentsPage';
import PromoCodesPage from './pages/PromoCodesPage';
import PricingPage from './pages/PricingPage';
import SiteStatusPage from './pages/SiteStatusPage';
import MetricsPage from './pages/MetricsPage';
import ReferralsPage from './pages/ReferralsPage';
import './App.scss';

function ProtectedAdminPage({ children }) {
    return (
        <ProtectedRoute>
            <AdminLayout>{children}</AdminLayout>
        </ProtectedRoute>
    );
}

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/login" element={<LoginPage />} />

                    <Route path="/" element={<ProtectedAdminPage><DashboardPage /></ProtectedAdminPage>} />
                    <Route path="/servers" element={<ProtectedAdminPage><ServersPage /></ProtectedAdminPage>} />
                    <Route path="/customers" element={<ProtectedAdminPage><CustomersPage /></ProtectedAdminPage>} />
                    <Route path="/subscriptions" element={<ProtectedAdminPage><SubscriptionsPage /></ProtectedAdminPage>} />
                    <Route path="/payments" element={<ProtectedAdminPage><PaymentsPage /></ProtectedAdminPage>} />
                    <Route path="/promo-codes" element={<ProtectedAdminPage><PromoCodesPage /></ProtectedAdminPage>} />
                    <Route path="/pricing" element={<ProtectedAdminPage><PricingPage /></ProtectedAdminPage>} />
                    <Route path="/site-status" element={<ProtectedAdminPage><SiteStatusPage /></ProtectedAdminPage>} />
                    <Route path="/metrics" element={<ProtectedAdminPage><MetricsPage /></ProtectedAdminPage>} />
                    <Route path="/referrals" element={<ProtectedAdminPage><ReferralsPage /></ProtectedAdminPage>} />

                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
